import { Assets } from '@core/GUI/Utils/Assets';
import { Constants, effectsVolume } from '@core/Utils/Constants';
import { Chip } from '@core/GUI/Chip';
import { Phase, BET_CHECKING_MODE } from '@core/Logic/Logic';
import { MiscButton } from '@core/GUI/MiscButton';
import { Language, Messages } from '@core/GUI/Language';
import { HotSpot } from '@core/GUI/HotSpot';
import { BetsDisplay } from '@core/GUI/BetsDisplay';
import { RedLeftTrack, BlackLeftTrack, RedRightTrack, BlackRightTrack, RepeatBets, UndoBet } from '@core/Utils/ButtonActions';
import { ButtonAction } from 'BaseRoulette/Sources/GUI/LayoutSwitchButton';
import { BettableButton } from '@core/GUI/BettableButton';
import { Client } from '@core/Client';
import { StatsHolder } from '@core/GUI/StatsHolder';
import { Button } from '@core/GUI/Button';

export class Track extends Phaser.GameObjects.Container {
	public statisticsAreDisplayed: boolean = false;

	public trackButtons = new Array<BettableButton>();
	public trackScale: number;
	public hotSpotsTableTrack: HotSpot[][];
	public trackBetsDisplay: BetsDisplay;

	protected trackButtonsDictionary = new Array<BettableButton>();
	protected trackBackground: Phaser.GameObjects.Image;
	protected sourceButton = { width: 0, height: 0 };
	protected displayedChips = new Array<Array<Chip>>();
	protected chipTextures = new Array<string>();
	protected assets = new Assets();
	protected isTrackEmpty: boolean = true;
	protected generalOffsetY: number;
	protected normalHotSpotOffsetsDictionary = new Array<{ offsetX: number, offsetY: number }>();
	protected initializedHotSpotOfssetsDictionary = new Array<{ offsetX: number, offsetY: number }>();
	protected inputRect: Phaser.GameObjects.Rectangle;
	protected trackNumbers: Array<number> = [0, 32, 15, 19, 4, 21, 26, 3, 35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24, 5, 10, 23, 8, 30, 11, 36, 13, 27, 6, 34, 17, 25, 2, 37];
	protected referenceRect: Phaser.Geom.Rectangle = new Phaser.Geom.Rectangle();
	protected numberStatistics;
	protected statisticsBars: Array<StatsHolder>;
	protected repeatBtn: MiscButton;
	protected winAnimation: Array<Phaser.Tweens.Tween> = new Array<Phaser.Tweens.Tween>();

	protected zeroGameCenterPresetText: Phaser.GameObjects.Text;
	protected bigSeriesCenterPreset: TrackCenterPreset;
	protected zeroGameCenterPreset: TrackCenterPreset;
	protected orphansCenterPreset: TrackCenterPreset;
	protected series58CenterPreset: TrackCenterPreset;
	protected bigSeriesCenterPresetText: Phaser.GameObjects.Text;
	protected orphansCenterPresetText: Phaser.GameObjects.Text;
	protected series58CenterPresetText: Phaser.GameObjects.Text;
	protected secondaryOrphansText: Phaser.GameObjects.Text;

	protected switchLayoutBtn: MiscButton | Button;
	protected undoBtn: MiscButton;
	protected presetBtn: MiscButton;
	protected redLeftBtn: MiscButton;
	protected redRightBtn: MiscButton;
	protected blackLeftBtn: MiscButton;
	protected blackRightBtn: MiscButton;

	constructor(scene: Phaser.Scene, protected textures: Phaser.Textures.TextureManager) {
		super(scene)

		this.trackBackground = new Phaser.GameObjects.Image(scene, 0, 0, Client.logic.IsDoubleZero() ? Constants.SPRITESHEET_TRACK_00 : Constants.SPRITESHEET_TRACK, "track_background.png")
		this.trackBackground.setOrigin(0.5)
		this.add(this.trackBackground)

		this.createTrackButtons();
		this.add(this.trackButtons);

		this.createTrackHotSpots()
		this.InitializeNormalHotSpotOffsets();
		this.InitializeExistingHotSpotOffsets();

		this.trackBetsDisplay = new BetsDisplay(this, this.scene, this.hotSpotsTableTrack, this.assets, true);
		this.trackBetsDisplay.RefreshChips();

		this.createCenterPresets();

		this.createMiscButtons();

		let buttonTexture = this.textures.get(Constants.SPRITESHEET).frames["board_button_1.png"];
		if(buttonTexture && buttonTexture.width)
			this.sourceButton = { width: buttonTexture.width, height: buttonTexture.height };
		else{
			buttonTexture = this.textures.get(Constants.SPRITESHEET).frames["boardButton_1.png"];
			this.sourceButton = { width: buttonTexture.width, height: buttonTexture.height };
		}

		let o = Assets.betChips;
		this.chipTextures = [];
		for (let i = 0; i < o.length; i++) {
			this.chipTextures.push(o[i].normal)
		};

		//on recovery Board is created too slowly to display wins right away!
		if (Client.logic.CurrentWinNumber != -1 && Client.logic.Phase == Phase.READING_WIN_NUMBER_STATE)
			this.displayWins(Client.logic.CurrentWinNumber);

		this.scene.game.events.on(Constants.EVENTS.WIN_NUMBER, (winNumber: number) => { this.displayWins(winNumber); }, this)
		this.scene.game.events.on(Constants.EVENTS.PHASE_EVENT, (phase: number) => { this.OnPhaseEvent(phase); }, this)
		this.scene.game.events.on(Constants.EVENTS.TOGGLE_TRACK_HOTSPOTS, (hotSpots: Array<number>, highlighted: boolean) => { this.ToggleButtonsHighLight(hotSpots, highlighted) }, this);
		this.scene.game.events.on(Constants.EVENTS.TOGGLE_BOARD_HOTSPOTS_EFFECTS, (enabled: boolean) => { this.ToggleHotSpotsEffects(enabled) }, this);
		this.scene.game.events.on(Constants.EVENTS.BETS_OPENED, () => { this.displayWins(-1); })

		this.inputRect = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, this.width, this.height);
		this.inputRect.setOrigin(0)
		this.inputRect.on("pointerout", () => {
			this.trackBetsDisplay.ToggleTouchPointer(false);
		})
		this.add(this.inputRect)
	}

	Update(time: number): void {
		if (this.trackBetsDisplay)
			this.trackBetsDisplay.Update(time);
		if (this.isTrackEmpty != Client.logic.IsEmpty)
			this.OnEmptyChanged(Client.logic.IsEmpty)

		// if (Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) {
		// 	this.undoBtn.TextElement.visible = this.undoBtn.visible = false;
		// 	if (this.presetBtn)
		// 		this.presetBtn.TextElement.visible = this.presetBtn.visible = false;
		// 	this.repeatBtn.TextElement.visible = this.repeatBtn.visible = false;
		// 	(this.switchLayoutBtn as MiscButton).TextElement.visible = this.switchLayoutBtn.visible = false;
		// } else {
		// 	this.undoBtn.TextElement.visible = this.undoBtn.visible = true;
		// 	if (this.presetBtn)
		// 		this.presetBtn.TextElement.visible = this.presetBtn.visible = true;
		// 	this.repeatBtn.TextElement.visible = this.repeatBtn.visible = true;
		// 	(this.switchLayoutBtn as MiscButton).TextElement.visible = (this.switchLayoutBtn as MiscButton).visible = true;
		// }
	}

	OnEmptyChanged(value: boolean) {
		this.isTrackEmpty = value;
		// this.repeatBtn.TextElement.text = this.isTrackEmpty ? Language.Get(Messages.REPEAT) : Language.Get(Messages.DOUBLE);
		// this.repeatBtn.AlignText(0.515, 0.7)
	}

	protected createTrackButtons(): void {
		let sprites = Constants.SPRITESHEET_TRACK
		let frames = "track_button_"
		if (Client.logic.IsDoubleZero()) {
			sprites = Constants.SPRITESHEET_TRACK_00
			frames += "00_"
		}
		this.trackButtons.fill(null, 0, 38)
		this.trackNumbers.forEach(n => {
			if (n == 37 && !Client.logic.IsDoubleZero()) return;
			let baseTexName = frames + n.toString();
			let textureSize = this.textures.get(sprites).frames[baseTexName + ".png"];
			let button = new BettableButton(n.toString(), sprites, this.scene, 0, 0, textureSize.width, textureSize.height, baseTexName + ".png", baseTexName + "_hover.png", baseTexName + "_win.png");
			this.trackButtons[n] = button;
			this.trackButtonsDictionary[n] = button;
		});
	}

	protected createCenterPresets(): void {
		if (Client.logic.IsDoubleZero()) {
			this.zeroGameCenterPreset = new TrackCenterPreset(this.scene, [[0, 37], [192, 78], [344, 93], [511, 94], [701, 76], [884, 37], [758, 4], [601, 2], [461, 1], [152, 0], [64, 10], [0, 36]], Constants.TRACK.BET_NAMES.ZERO_GAME, this.trackBetsDisplay)
			this.bigSeriesCenterPreset = new TrackCenterPreset(this.scene, [[132, 48], [132, 48], [54, 94], [20, 142], [14, 188], [158, 188], [381, 168], [783, 106], [907, 90], [1070, 84], [1024, 53], [933, 23], [814, 11], [711, 14], [641, 54], [546, 71], [390, 65], [289, 18]], Constants.TRACK.BET_NAMES.BIG_SERIES, this.trackBetsDisplay)
			this.orphansCenterPreset = new TrackCenterPreset(this.scene, [[989, 261], [1061, 218], [1106, 158], [1106, 107], [1070, 47], [1025, 12], [1005, 0], [791, 47], [599, 61], [372, 56], [108, 1], [35, 50], [0, 115], [25, 190], [112, 259], [228, 229], [396, 202], [593, 193], [763, 206], [901, 235], [989, 261]], Constants.TRACK.BET_NAMES.ORPHANS, this.trackBetsDisplay, Constants.TRACK.BLUE_COLOR)
			this.series58CenterPreset = new TrackCenterPreset(this.scene, [[0, 53], [154, 22], [298, 1], [506, 0], [640, 9], [848, 57], [767, 78], [694, 83], [121, 84], [33, 68], [0, 53]], Constants.TRACK.BET_NAMES.SERIE_58, this.trackBetsDisplay, Constants.TRACK.BLUE_COLOR)
		} else {
			this.zeroGameCenterPreset = new TrackCenterPreset(this.scene, [[185, 3], [185, 3], [379, 1], [363, 16], [281, 43], [196, 47], [98, 36], [0, 0]], Constants.TRACK.BET_NAMES.ZERO_GAME, this.trackBetsDisplay)
			this.bigSeriesCenterPreset = new TrackCenterPreset(this.scene, [[132, 48], [132, 48], [54, 94], [20, 142], [14, 188], [158, 188], [381, 168], [783, 106], [907, 90], [1070, 84], [1024, 53], [933, 23], [814, 11], [711, 14], [641, 54], [546, 71], [390, 65], [289, 18]], Constants.TRACK.BET_NAMES.BIG_SERIES, this.trackBetsDisplay)
			this.orphansCenterPreset = new TrackCenterPreset(this.scene, [[12, 121], [12, 121], [43, 174], [158, 234], [303, 255], [446, 184], [574, 149], [739, 129], [922, 131], [1090, 152], [1110, 99], [1098, 48], [1073, 10], [1041, 3], [884, 15], [708, 36], [533, 68], [341, 92], [196, 106]], Constants.TRACK.BET_NAMES.ORPHANS, this.trackBetsDisplay, Constants.TRACK.BLUE_COLOR)
			this.series58CenterPreset = new TrackCenterPreset(this.scene, [[12, 118], [12, 118], [538, 114], [676, 72], [732, 30], [638, 16], [440, 6], [285, 19], [152, 46], [39, 96]], Constants.TRACK.BET_NAMES.SERIE_58, this.trackBetsDisplay, Constants.TRACK.BLUE_COLOR)
		}

		this.add(this.zeroGameCenterPreset)
		this.add(this.bigSeriesCenterPreset)
		this.add(this.orphansCenterPreset)
		this.add(this.series58CenterPreset)

		let font = { fontFamily: Constants.BOARD.MISC_BUTTON_FONT.fontFamily }

		this.add(this.zeroGameCenterPresetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.ZERO_GAME), font))
		this.add(this.bigSeriesCenterPresetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.TRACK_BIG_SERIES), font))
		this.add(this.orphansCenterPresetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.ORPHANS), font))
		this.add(this.secondaryOrphansText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.ORPHANS), font))

		if (Client.logic.IsDoubleZero()) this.secondaryOrphansText.text = ""

		// Change to the code in the next line when double zero game preset is implemented and working
		this.add(this.series58CenterPresetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get((Client.logic.IsDoubleZero() ? Messages.DOUBLE_ZERO_GAME : Messages.SERIE_58)), font))
		// this.add(this.series58CenterPresetText = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(Messages.SERIE_58), {}))
	}

	protected positionTrackElement(element: Phaser.GameObjects.Components.Transform, x: number, y: number) {
		element.setPosition(this.width / 2 + this.trackScale * x, y * this.trackScale + this.generalOffsetY);
	}

	protected positionTrackButtons(viewportWidth: number, viewportHeight: number, boardY: number, buttonW: number, buttonH: number, portraitMode: boolean, boardHeight: number): void {
		let availHeight = boardHeight;
		let availWidth = viewportWidth * (1 - 2 * Constants.TRACK.HORIZONTAL_MARGIN)

		this.trackScale = Math.min(availHeight / (Constants.TRACK.TEXTURE_ORIGINAL_WIDTH / Constants.TRACK.TRACK_W_TO_H_RATIO), availWidth / Constants.TRACK.TEXTURE_ORIGINAL_WIDTH)

		this.width = viewportWidth - (2 * Constants.BOARD.RELATIVE_SIDE_MARGIN);
		this.height = availHeight

		this.referenceRect.width = Constants.TRACK.TEXTURE_ORIGINAL_WIDTH * this.trackScale
		this.referenceRect.height = this.referenceRect.width / Constants.TRACK.TRACK_W_TO_H_RATIO
		this.referenceRect.x = (this.width - this.referenceRect.width) / 2
		this.referenceRect.y = (this.height - this.referenceRect.height) / 2
		this.generalOffsetY = this.trackScale * Constants.TRACK.OFFSET_DUE_TO_ORIGIN

		this.setPosition((viewportWidth - this.width) / 2, boardY + (availHeight - this.height) / 2);

		this.positionTrackElement(this.trackBackground, 0, 218)
		this.trackBackground.setPosition(this.width / 2, this.height / 2)
		this.trackBackground.setScale(this.trackScale)

		this.positionTrackElement(this.trackButtons[0], 0, 0)

		if (Client.logic.IsDoubleZero()) {
			this.positionTrackElement(this.trackButtons[2], -68.5, 0)
			this.positionTrackElement(this.trackButtons[14], -135.5, 0)
			this.positionTrackElement(this.trackButtons[35], -212.5, 0)
			this.positionTrackElement(this.trackButtons[23], -305, 0)

			this.positionTrackElement(this.trackButtons[28], 68.5, 0)
			this.positionTrackElement(this.trackButtons[9], 136.5, 0)
			this.positionTrackElement(this.trackButtons[26], 214.5, -1)
			this.positionTrackElement(this.trackButtons[30], 305, -1)

			this.positionTrackElement(this.trackButtons[11], 399.5, 5)
			this.positionTrackElement(this.trackButtons[7], 486.5, 29)
			this.positionTrackElement(this.trackButtons[20], 556, 71)
			this.positionTrackElement(this.trackButtons[32], 606, 124)
			this.positionTrackElement(this.trackButtons[17], 634, 183)
			this.positionTrackElement(this.trackButtons[5], 634, 252)
			this.positionTrackElement(this.trackButtons[22], 607.5, 312)
			this.positionTrackElement(this.trackButtons[34], 556.5, 364)
			this.positionTrackElement(this.trackButtons[15], 484.5, 407)
			this.positionTrackElement(this.trackButtons[3], 399.5, 432.5)

			this.positionTrackElement(this.trackButtons[24], 305.5, 438)
			this.positionTrackElement(this.trackButtons[36], 216, 438)
			this.positionTrackElement(this.trackButtons[13], 138, 438)
			this.positionTrackElement(this.trackButtons[1], 70, 438)
			this.positionTrackElement(this.trackButtons[37], 0, 437.5)
			this.positionTrackElement(this.trackButtons[27], -70, 437.5)
			this.positionTrackElement(this.trackButtons[10], -138, 437.5)
			this.positionTrackElement(this.trackButtons[25], -215, 437.5)
			this.positionTrackElement(this.trackButtons[29], -306, 437.5)
			this.positionTrackElement(this.trackButtons[12], -400.5, 432)

			this.positionTrackElement(this.trackButtons[8], -485, 407)
			this.positionTrackElement(this.trackButtons[19], -557, 365)
			this.positionTrackElement(this.trackButtons[31], -607, 313.5)
			this.positionTrackElement(this.trackButtons[18], -633, 253)
			this.positionTrackElement(this.trackButtons[6], -634, 183.5)
			this.positionTrackElement(this.trackButtons[21], -607.7, 124.5)
			this.positionTrackElement(this.trackButtons[33], -556, 70)
			this.positionTrackElement(this.trackButtons[16], -485, 30)
			this.positionTrackElement(this.trackButtons[4], -398, 5)
		} else {
			this.positionTrackElement(this.trackButtons[32], 74, 0)
			this.positionTrackElement(this.trackButtons[15], 143, 0)
			this.positionTrackElement(this.trackButtons[19], 224, 0)
			this.positionTrackElement(this.trackButtons[4], 318, 0)
			this.positionTrackElement(this.trackButtons[21], 414, 6)

			this.positionTrackElement(this.trackButtons[26], -73, 0)
			this.positionTrackElement(this.trackButtons[3], -143, 0)
			this.positionTrackElement(this.trackButtons[35], -224, 0)
			this.positionTrackElement(this.trackButtons[12], -318, 0)
			this.positionTrackElement(this.trackButtons[28], -413, 6.5)

			this.positionTrackElement(this.trackButtons[7], -501, 34.5)
			this.positionTrackElement(this.trackButtons[29], -571, 79.5)
			this.positionTrackElement(this.trackButtons[18], -619, 136)
			this.positionTrackElement(this.trackButtons[22], -641, 200)
			this.positionTrackElement(this.trackButtons[9], -634, 269)
			this.positionTrackElement(this.trackButtons[31], -599.5, 329)
			this.positionTrackElement(this.trackButtons[14], -540, 381)
			this.positionTrackElement(this.trackButtons[20], -461, 419)
			this.positionTrackElement(this.trackButtons[1], -368.5, 438)

			this.positionTrackElement(this.trackButtons[33], -273.5, 440)
			this.positionTrackElement(this.trackButtons[16], -185.5, 441)
			this.positionTrackElement(this.trackButtons[24], -109, 441)
			this.positionTrackElement(this.trackButtons[5], -42, 441)

			this.positionTrackElement(this.trackButtons[10], 40, 441)
			this.positionTrackElement(this.trackButtons[23], 107, 441)
			this.positionTrackElement(this.trackButtons[8], 182, 441)
			this.positionTrackElement(this.trackButtons[30], 271, 441)
			this.positionTrackElement(this.trackButtons[11], 367, 439)

			this.positionTrackElement(this.trackButtons[36], 460, 419)
			this.positionTrackElement(this.trackButtons[13], 538, 381)
			this.positionTrackElement(this.trackButtons[27], 597, 330)
			this.positionTrackElement(this.trackButtons[6], 632, 269.5)
			this.positionTrackElement(this.trackButtons[34], 638, 200)
			this.positionTrackElement(this.trackButtons[17], 617, 136)
			this.positionTrackElement(this.trackButtons[25], 568, 80)
			this.positionTrackElement(this.trackButtons[2], 500.5, 35)
		}

		this.trackButtons.forEach(button => {
			button.setScale(this.trackScale)
			// this.scene.input.enableDebug(button, Constants.TRACK.DEBUG_BUTTON_COLOR)
		});

		if (Client.logic.IsDoubleZero()) {
			this.bigSeriesCenterPreset.setVisible(false)
			this.bigSeriesCenterPresetText.setVisible(false)

			this.positionTrackElement(this.zeroGameCenterPreset, 10, 100)
			this.zeroGameCenterPreset.setScale(this.trackScale)

			this.positionTrackElement(this.orphansCenterPreset, 0, 220)
			this.orphansCenterPreset.setScale(this.trackScale)

			this.positionTrackElement(this.series58CenterPreset, 0, 340)
			this.series58CenterPreset.setScale(this.trackScale)

			let v = this.orphansCenterPreset.getCenter()
			this.orphansCenterPresetText.setScale(this.trackScale * 1.7)
			this.orphansCenterPresetText.setOrigin(0.5, 0)
			this.orphansCenterPresetText.setPosition(v.x - 12 * this.trackScale, v.y - this.orphansCenterPresetText.displayHeight / 1.9)
			this.secondaryOrphansText.setScale(this.trackScale * 1.7)
			this.secondaryOrphansText.setOrigin(0.5, 0)
			this.secondaryOrphansText.setPosition(this.orphansCenterPresetText.x, this.orphansCenterPresetText.y)

			let orphansPosX = this.orphansCenterPresetText.x
			v = this.zeroGameCenterPreset.getCenter()
			this.zeroGameCenterPresetText.setScale(this.trackScale * 1.7)
			this.zeroGameCenterPresetText.setOrigin(0.5, 0)
			this.zeroGameCenterPresetText.setPosition(orphansPosX, v.y - this.zeroGameCenterPresetText.displayHeight / 1.4)

			v = this.series58CenterPreset.getCenter()
			this.series58CenterPresetText.setScale(this.trackScale * 1.7)
			this.series58CenterPresetText.setOrigin(0.5, 0)
			this.series58CenterPresetText.setPosition(orphansPosX, v.y - this.series58CenterPresetText.displayHeight / 2)
		} else {
			this.positionTrackElement(this.zeroGameCenterPreset, -60, 80)
			this.zeroGameCenterPreset.setScale(this.trackScale)
			this.positionTrackElement(this.bigSeriesCenterPreset, -30, 130)
			this.bigSeriesCenterPreset.setScale(this.trackScale)
			this.positionTrackElement(this.orphansCenterPreset, 5, 255)
			this.orphansCenterPreset.setScale(this.trackScale)
			this.positionTrackElement(this.series58CenterPreset, 165, 325)
			this.series58CenterPreset.setScale(this.trackScale)

			let v = this.zeroGameCenterPreset.getCenter()
			this.zeroGameCenterPresetText.setScale(this.trackScale * 1.7)
			this.zeroGameCenterPresetText.setOrigin(0.5, 0)
			this.zeroGameCenterPresetText.setPosition(v.x + 8 * this.trackScale, v.y - this.zeroGameCenterPresetText.displayHeight + 10 * this.trackScale)

			v = this.bigSeriesCenterPreset.getLeftCenter()
			this.bigSeriesCenterPresetText.setScale(this.trackScale * 1.7)
			this.bigSeriesCenterPresetText.setPosition(v.x + 125 * this.trackScale, v.y)

			v = this.orphansCenterPreset.getRightCenter()
			this.orphansCenterPresetText.setScale(this.trackScale * 1.7)
			this.orphansCenterPresetText.setPosition(v.x - this.orphansCenterPresetText.displayWidth * 2, v.y - this.orphansCenterPresetText.displayHeight * 2.10)
			this.secondaryOrphansText.setScale(this.trackScale * 1.7)
			this.secondaryOrphansText.setOrigin(0, 1)
			this.secondaryOrphansText.setPosition(this.bigSeriesCenterPresetText.x, (this.orphansCenterPreset.getBottomLeft().y + this.orphansCenterPreset.getLeftCenter().y) / 2)

			v = this.series58CenterPreset.getCenter()
			this.series58CenterPresetText.setScale(this.trackScale * 1.7)
			this.series58CenterPresetText.setPosition(v.x - this.series58CenterPresetText.displayWidth / 2, v.y - this.series58CenterPresetText.displayHeight / 2)
		}
	}

	protected defineHotSpot(
		x: number,
		y: number,
		buttonNumbers: number[],
		verts: number[][],
		offsetX: number = 0,
		offsetY: number = 0,
		checkTouch: boolean = false,
		betMode?: BET_CHECKING_MODE[],
		kavalSize?: {
			width: number,
			height: number
		}): void {
		if (!betMode) betMode = [BET_CHECKING_MODE.NONE]
		this.hotSpotsTableTrack[x][y] = new HotSpot(this.scene, x, y, verts, offsetX, offsetY, true, checkTouch, betMode, kavalSize ? kavalSize : { width: 0, height: 0 })
		this.hotSpotsTableTrack[x][y].AddButton(buttonNumbers.map(el => this.trackButtons[el]))
	}

	protected createTrackHotSpots(): void {
		this.hotSpotsTableTrack = new Array(28)
		this.displayedChips = new Array(28)
		for (var x = 0; x < this.hotSpotsTableTrack.length; x++) {
			this.hotSpotsTableTrack[x] = new Array(11)
			this.displayedChips[x] = new Array(11)
		}

		let relativeToMin = (vertArray: any): any[] => {
			let vsiX = []
			let vsiY = []
			vertArray.forEach(b => {
				vsiX.push(b[0])
				vsiY.push(b[1])
			});
			let smallestX = vsiX.reduce(function (p, v) { return (p < v ? p : v) })
			let smallestY = vsiY.reduce(function (p, v) { return (p < v ? p : v) })
			let newArr = []
			vertArray.forEach(b => {
				newArr.push([b[0] - smallestX, b[1] - smallestY])
			});
			return newArr
		}

		// bet checking modes.
		let upArra: Array<BET_CHECKING_MODE> = new Array();
		let downArra: Array<BET_CHECKING_MODE> = new Array();
		let leftArra: Array<BET_CHECKING_MODE> = new Array();
		let rightArra: Array<BET_CHECKING_MODE> = new Array();
		upArra.push(BET_CHECKING_MODE.TOP)
		downArra.push(BET_CHECKING_MODE.BOTTOM)
		leftArra.push(BET_CHECKING_MODE.LEFT)
		rightArra.push(BET_CHECKING_MODE.RIGHT)

		let upDownKavalSize = { width: 96, height: 42 };
		let leftRightKavalSize = { width: 93, height: 63 };

		if (Client.logic.IsDoubleZero()) {
			//zgornji ravni del elipse
			this.defineHotSpot(16, 3, [23], relativeToMin([[723.5, 458.3], [653, 394.8], [529.5, 396.1], [632.3, 461.9], [683.4, 458.7], [723.5, 458.3]]), 15, 0, true, downArra, upDownKavalSize) //23
			this.defineHotSpot(24, 3, [35], relativeToMin([[802.7, 458], [755.1, 394.7], [653, 394.8], [723.5, 458.3], [767.1, 458.2], [802.7, 458]]), 7, 0, true, upArra) //35
			this.defineHotSpot(10, 3, [14], relativeToMin([[869.5, 457.8], [842, 394.7], [755.1, 394.7], [802.7, 458], [840.4, 457.7], [869.5, 457.8]]), 13, 0, true, leftArra) //14
			this.defineHotSpot(2, 3, [2], relativeToMin([[931.7, 457.9], [923.1, 394.6], [842, 394.7], [869.5, 457.8], [901.6, 458], [931.7, 457.9]]), 0, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.TOP), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) //2
			this.defineHotSpot(0, 3, [0], relativeToMin([[991.9, 457.9], [1001.1, 394.6], [923.1, 394.6], [931.7, 457.9], [961.1, 458], [991.9, 457.9]]), 0, 0, true, upArra) //0
			// Test with server set to double zero!
			// this.defineHotSpot(0, 5, [0], relativeToMin([[985.9, 500.1], [1001.1, 394.6], [923.1, 394.6], [937.5, 500.1], [963.3, 499.9], [985.9, 500.1]]), 0, 0, true, upArra) //0
			this.defineHotSpot(20, 5, [28], relativeToMin([[1054.4, 458.1], [1082.9, 394.5], [1001.1, 394.6], [991.9, 457.9], [1025.5, 458.1], [1054.4, 458.1]]), 0, 0, true, new Array(BET_CHECKING_MODE.LEFT, BET_CHECKING_MODE.TOP)) //28
			this.defineHotSpot(6, 1, [9], relativeToMin([[1121.9, 457.8], [1169.2, 394.5], [1082.9, 394.5], [1054.4, 458.1], [1085.4, 458.2], [1121.9, 457.8]]), 0, 0, true, leftArra) //9
			this.defineHotSpot(18, 3, [26], relativeToMin([[1200.7, 457.3], [1270.6, 394.5], [1169.2, 394.5], [1121.9, 457.8], [1158.5, 457.6], [1200.7, 457.3]]), 0, 0, true, upArra) //26
			this.defineHotSpot(20, 1, [30], relativeToMin([[1293.4, 460.5], [1397.1, 394.4], [1270.6, 394.5], [1200.7, 457.3], [1242.5, 457.2], [1293.4, 460.5]]), 0, 0, true, downArra, upDownKavalSize) //30
			// UNCOMMENT FOR DEBUGGING KAVALS
			let debug_kavals = false
			let debug_numbers = false
			if (debug_kavals) {
				this.hotSpotsTableTrack[16][3].setVisible(false)
				this.hotSpotsTableTrack[24][3].setVisible(false)
				this.hotSpotsTableTrack[10][3].setVisible(false)
				this.hotSpotsTableTrack[2][3].setVisible(false)
				this.hotSpotsTableTrack[0][3].setVisible(false)
				this.hotSpotsTableTrack[20][5].setVisible(false)
				this.hotSpotsTableTrack[6][1].setVisible(false)
				this.hotSpotsTableTrack[18][3].setVisible(false)
				this.hotSpotsTableTrack[20][1].setVisible(false)
			}

			//spodnji ravni del elipse
			this.defineHotSpot(20, 3, [29], relativeToMin([[631.2, 881.6], [528.9, 948.6], [655, 948.6], [724.4, 884.8], [677.8, 884.4], [631.2, 881.6]]), 5, 0, true, leftArra) //29
			this.defineHotSpot(18, 5, [25], relativeToMin([[724.4, 884.8], [655, 948.6], [756.7, 948.7], [803.3, 884.8], [762, 885], [724.4, 884.8]]), 0, 0, true, rightArra, leftRightKavalSize) //25
			this.defineHotSpot(8, 5, [10], relativeToMin([[803.3, 884.8], [756.7, 948.7], [844.1, 948.7], [871, 884.1], [838.3, 884.7], [803.3, 884.8]]), 0, 0, true, downArra, upDownKavalSize) //10
			this.defineHotSpot(18, 1, [27], relativeToMin([[871, 884.1], [844.1, 948.7], [924.7, 948.8], [932.7, 884.1], [903, 883.9], [871, 884.1]]), 0, 0, true, rightArra, leftRightKavalSize) //27
			this.defineHotSpot(0, 1, [37], relativeToMin([[932.7, 884.1], [924.7, 948.8], [1002.8, 948.8], [994.2, 884.3], [962.8, 884.3], [932.7, 884.1]]), 0, 0, true, downArra) //37 
			this.defineHotSpot(2, 5, [1], relativeToMin([[994.2, 884.3], [1002.8, 948.8], [1083.8, 949.2], [1054.9, 883.8], [1023.1, 883.9], [994.2, 884.3]]), -5, 0, true, downArra, upDownKavalSize) //1
			this.defineHotSpot(10, 5, [13], relativeToMin([[1054.9, 883.8], [1083.8, 949.2], [1171.8, 949.5], [1124, 884.1], [1088.2, 884.4], [1054.9, 883.8]]), -5, 0, true, rightArra, { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) //13
			this.defineHotSpot(24, 1, [36], relativeToMin([[1124, 884.1], [1171.8, 949.5], [1273.2, 949.6], [1200.5, 884], [1162, 884.3], [1124, 884.1]]), 0, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.BOTTOM), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) //36
			this.defineHotSpot(16, 1, [24], relativeToMin([[1200.5, 884], [1273.2, 949.6], [1397.8, 948.3], [1297.5, 882.8], [1248.3, 884.7], [1200.5, 884]]), 0, 0, true, downArra, upDownKavalSize) //24
			// UNCOMMENT FOR DEBUGGING KAVALS
			if (debug_kavals) {
				this.hotSpotsTableTrack[20][3].setVisible(false)
				this.hotSpotsTableTrack[18][5].setVisible(false)
				this.hotSpotsTableTrack[8][5].setVisible(false)
				this.hotSpotsTableTrack[18][1].setVisible(false)
				this.hotSpotsTableTrack[0][1].setVisible(false)
				this.hotSpotsTableTrack[2][5].setVisible(false)
				this.hotSpotsTableTrack[10][5].setVisible(false)
				this.hotSpotsTableTrack[24][1].setVisible(false)
				this.hotSpotsTableTrack[16][1].setVisible(false)
			}

			//leva stran
			this.defineHotSpot(8, 1, [12], relativeToMin([[533.9, 866.9], [421.2, 918.8], [528.9, 948.6], [631.2, 881.6], [575.7, 878.2], [533.9, 866.9]]), 0, 0, true, upArra) //12
			this.defineHotSpot(6, 3, [8], relativeToMin([[451.9, 833.1], [333.4, 870.5], [421.2, 918.8], [532.6, 867.3], [491.7, 856.3], [451.9, 833.1]]), 0, 0, true, downArra, upDownKavalSize) //8
			this.defineHotSpot(14, 5, [19], relativeToMin([[389, 787], [274, 810.4], [333.4, 870.5], [451.9, 833.1], [415.7, 813.2], [389, 787]]), -3, -2, true, upArra) //19
			this.defineHotSpot(22, 5, [31], relativeToMin([[348.2, 732.7], [238.9, 742.8], [274, 810.4], [389, 787], [361.1, 760.1], [348.2, 732.7]]), 0, 0, true, leftArra) //31
			this.defineHotSpot(12, 1, [18], relativeToMin([[333.7, 672.6], [226.7, 672.7], [238.9, 742.8], [348.2, 732.7], [333.3, 701.3], [333.7, 672.6]]), 0, 0, true, leftArra) //18
			this.defineHotSpot(4, 1, [6], relativeToMin([[347.8, 611.9], [240.6, 601.1], [226.7, 672.7], [333.7, 672.6], [334.1, 642.2], [347.8, 611.9]]), 0, 0, true, rightArra, leftRightKavalSize) //6
			this.defineHotSpot(14, 1, [21], relativeToMin([[387.8, 557.2], [276.9, 534.3], [240.6, 601.1], [347.8, 611.9], [359.9, 585.3], [387.8, 557.2]]), 0, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.TOP), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) //21
			this.defineHotSpot(22, 1, [33], relativeToMin([[451.6, 510.1], [336.8, 472.8], [276.9, 534.3], [387.8, 557.2], [413.6, 531.2], [451.6, 510.1]]), 0, 0, true, downArra, upDownKavalSize) //33
			this.defineHotSpot(12, 5, [16], relativeToMin([[535.9, 477.8], [421.2, 424.8], [336.8, 472.8], [451.6, 510.1], [455.6, 507.6], [471.1, 498.6]]), 0, 0, true, downArra, upDownKavalSize) //16
			this.defineHotSpot(4, 5, [4], relativeToMin([[632.3, 461.9], [529.5, 396.1], [421.2, 424.8], [535.9, 477.8], [582.4, 465], [632.3, 461.9]]), 0, 0, true, upArra) //4
			// UNCOMMENT FOR DEBUGGING KAVALS
			if (debug_kavals) {
				this.hotSpotsTableTrack[8][1].setVisible(false)
				this.hotSpotsTableTrack[6][3].setVisible(false)
				this.hotSpotsTableTrack[14][5].setVisible(false)
				this.hotSpotsTableTrack[22][5].setVisible(false)
				this.hotSpotsTableTrack[12][1].setVisible(false)
				this.hotSpotsTableTrack[4][1].setVisible(false)
				this.hotSpotsTableTrack[14][1].setVisible(false)
				this.hotSpotsTableTrack[22][1].setVisible(false)
				this.hotSpotsTableTrack[12][5].setVisible(false)
				this.hotSpotsTableTrack[4][5].setVisible(false)
			}

			//desna stran
			this.defineHotSpot(8, 3, [11], relativeToMin([[1389.2, 476.6], [1509.8, 420.9], [1397.1, 394.4], [1293.4, 460.5], [1345.2, 464], [1389.2, 476.6]]), 0, 0, true, downArra, upDownKavalSize) //11
			this.defineHotSpot(6, 5, [7], relativeToMin([[1472.1, 509.4], [1590.7, 471.4], [1509.8, 420.9], [1389.2, 476.6], [1435.7, 490], [1472.1, 509.4]]), 0, 0, true, leftArra) //7
			this.defineHotSpot(14, 3, [20], relativeToMin([[1536.6, 555.9], [1656.4, 531.6], [1590.7, 471.4], [1472.1, 509.4], [1510.5, 529.9], [1536.6, 555.9]]), 0, 0, true, leftArra) //20
			this.defineHotSpot(22, 3, [32], relativeToMin([[1576, 610.9], [1692.5, 599.2], [1656.4, 531.6], [1536.6, 555.9], [1563.4, 582.5], [1576, 610.9]]), 0, 0, true, upArra) //32
			this.defineHotSpot(12, 3, [17], relativeToMin([[1589.1, 671.2], [1701.7, 670.7], [1692.5, 599.2], [1576, 610.9], [1590.1, 642.7], [1589.1, 671.2]]), 0, 0, true, rightArra, leftRightKavalSize) //17
			this.defineHotSpot(4, 3, [5], relativeToMin([[1576.4, 729.7], [1691.6, 741.1], [1701.7, 670.7], [1589.1, 671.2], [1588.2, 701.9], [1576.4, 729.7]]), 0, 0, true, downArra, upDownKavalSize) //5
			this.defineHotSpot(16, 5, [22], relativeToMin([[1537.3, 785.3], [1656.4, 810.9], [1691.6, 741.1], [1576.4, 729.7], [1563.7, 760], [1537.3, 785.3]]), 0, 0, true, leftArra) //22
			this.defineHotSpot(24, 5, [34], relativeToMin([[1473.3, 831.9], [1594.5, 870.9], [1656.4, 810.9], [1537.3, 785.3], [1506.8, 813.5], [1473.3, 831.9]]), 0, 0, true, rightArra, leftRightKavalSize) //34
			this.defineHotSpot(10, 1, [15], relativeToMin([[1390.6, 865.7], [1511.2, 920.7], [1594.5, 870.9], [1473.3, 831.9], [1436.2, 852.3], [1390.6, 865.7]]), 0, 0, true, upArra) //15
			this.defineHotSpot(2, 1, [3], relativeToMin([[1297.5, 882.8], [1397.8, 948.3], [1511.2, 920.7], [1390.6, 865.7], [1347.8, 876.8], [1297.5, 882.8]]), 0, 0, true, upArra) //3
			// UNCOMMENT FOR DEBUGGING KAVALS
			if (debug_kavals) {
				this.hotSpotsTableTrack[8][3].setVisible(false)
				this.hotSpotsTableTrack[6][5].setVisible(false)
				this.hotSpotsTableTrack[14][3].setVisible(false)
				this.hotSpotsTableTrack[22][3].setVisible(false)
				this.hotSpotsTableTrack[12][3].setVisible(false)
				this.hotSpotsTableTrack[4][3].setVisible(false)
				this.hotSpotsTableTrack[16][5].setVisible(false)
				this.hotSpotsTableTrack[24][5].setVisible(false)
				this.hotSpotsTableTrack[10][1].setVisible(false)
				this.hotSpotsTableTrack[2][1].setVisible(false)
			}

			/** KAVALI NA TRACKU */
			//kavali zgoraj
			this.defineHotSpot(7, 10, [4, 23], relativeToMin([[734.4, 500.1], [683.4, 458.7], [582.4, 465], [648.7, 503.7], [692.6, 500.4], [734.4, 500.1]])) //4-23
			this.defineHotSpot(8, 10, [23, 35], relativeToMin([[804.4, 499.8], [767.1, 458.2], [683.4, 458.7], [734.4, 500.1], [769.9, 500.1], [804.4, 499.8]])) //23-35
			this.defineHotSpot(9, 10, [35, 14], relativeToMin([[859.5, 499.8], [840.4, 457.7], [767.1, 458.2], [804.4, 499.8], [834.1, 499.7], [859.5, 499.8]])) //35-14
			this.defineHotSpot(10, 10, [14, 2], relativeToMin([[913.1, 500], [901.6, 458], [840.4, 457.7], [859.5, 499.8], [888.2, 499.9], [913.1, 500]])) //14-2
			this.defineHotSpot(11, 10, [2, 0], relativeToMin([[960.8, 499.9], [961.1, 458], [901.6, 458], [913.1, 500], [937.5, 500.1], [960.8, 499.9]])) //2-0
			this.defineHotSpot(0, 9, [0, 28], relativeToMin([[1009.1, 499.6], [1025.5, 458.1], [961.1, 458], [960.8, 499.9], [986.1, 499.8], [1009.1, 499.6]])) //28-0
			this.defineHotSpot(1, 9, [28, 9], relativeToMin([[1059.2, 499.6], [1085.4, 458.2], [1025.5, 458.1], [1009.1, 499.6], [1035, 499.6], [1059.2, 499.6]])) //9-28
			this.defineHotSpot(2, 9, [9, 26], relativeToMin([[1120.6, 499.9], [1158.5, 457.6], [1085.4, 458.2], [1059.2, 499.6], [1090.5, 500], [1120.6, 499.9]])) //26-9
			this.defineHotSpot(3, 9, [26, 30], relativeToMin([[1192.7, 499.2], [1242.5, 457.2], [1158.5, 457.6], [1120.6, 499.9], [1153.6, 499.9], [1192.7, 499.2]])) //30-26
			this.defineHotSpot(4, 9, [30, 11], relativeToMin([[1282.6, 503.9], [1345.2, 464], [1242.5, 457.2], [1192.7, 499.2], [1232.2, 499.9], [1282.6, 503.9]])) //11-30
			if (debug_numbers) {
				this.hotSpotsTableTrack[7][10].setVisible(false)
				this.hotSpotsTableTrack[8][10].setVisible(false)
				this.hotSpotsTableTrack[9][10].setVisible(false)
				this.hotSpotsTableTrack[10][10].setVisible(false)
				this.hotSpotsTableTrack[11][10].setVisible(false)
				this.hotSpotsTableTrack[0][9].setVisible(false)
				this.hotSpotsTableTrack[1][9].setVisible(false)
				this.hotSpotsTableTrack[2][9].setVisible(false)
				this.hotSpotsTableTrack[3][9].setVisible(false)
				this.hotSpotsTableTrack[4][9].setVisible(false)
			}

			//kavali desno 
			this.defineHotSpot(5, 9, [11, 7], relativeToMin([[1360.8, 520.8], [1435.7, 490], [1345.2, 464], [1282.6, 503.9], [1318.3, 510.1], [1360.8, 520.8]])) //7-11
			this.defineHotSpot(6, 9, [7, 20], relativeToMin([[1436.3, 553.4], [1510.5, 529.9], [1435.7, 490], [1360.8, 520.8], [1397.2, 534.1], [1436.3, 553.4]])) //20-7
			this.defineHotSpot(7, 9, [20, 32], relativeToMin([[1487.7, 595.2], [1563.4, 582.5], [1510.5, 529.9], [1436.3, 553.4], [1462.5, 571.2], [1487.7, 595.2]])) //32-20
			this.defineHotSpot(8, 9, [32, 17], relativeToMin([[1517.4, 646.6], [1590.1, 642.7], [1563.4, 582.5], [1487.7, 595.2], [1505.2, 618.1], [1517.4, 646.6]])) //17-32
			this.defineHotSpot(9, 9, [17, 5], relativeToMin([[1516.3, 697.9], [1588.2, 701.9], [1590.1, 642.7], [1517.4, 646.6], [1520.1, 671.6], [1516.3, 697.9]])) //5-17
			this.defineHotSpot(10, 9, [5, 22], relativeToMin([[1481.7, 752.3], [1563.7, 760], [1588.2, 701.9], [1516.3, 697.9], [1504.1, 724.4], [1481.7, 752.3]])) //5-22
			this.defineHotSpot(11, 9, [22, 34], relativeToMin([[1426.3, 794.7], [1506.8, 813.5], [1563.7, 760], [1481.7, 752.3], [1462.6, 770.4], [1426.3, 794.7]])) //22-34
			this.defineHotSpot(12, 9, [34, 15], relativeToMin([[1350.9, 823.7], [1436.2, 852.3], [1506.8, 813.5], [1426.3, 794.7], [1396.8, 808], [1350.9, 823.7]])) //34-15
			this.defineHotSpot(13, 9, [15, 3], relativeToMin([[1266.7, 838], [1347.8, 876.8], [1436.2, 852.3], [1350.9, 823.7], [1313.8, 832.1], [1266.7, 838]])) //15-3
			if (debug_numbers) {
				this.hotSpotsTableTrack[5][9].setVisible(false)
				this.hotSpotsTableTrack[6][9].setVisible(false)
				this.hotSpotsTableTrack[7][9].setVisible(false)
				this.hotSpotsTableTrack[8][9].setVisible(false)
				this.hotSpotsTableTrack[9][9].setVisible(false)
				this.hotSpotsTableTrack[10][9].setVisible(false)
				this.hotSpotsTableTrack[11][9].setVisible(false)
				this.hotSpotsTableTrack[12][9].setVisible(false)
				this.hotSpotsTableTrack[13][9].setVisible(false)
			}

			//kavali spodaj
			this.defineHotSpot(14, 9, [3, 24], relativeToMin([[1195.2, 840.3], [1248.3, 884.7], [1347.8, 876.8], [1266.7, 838], [1228.9, 840.2], [1195.2, 840.3]])) //3-24
			this.defineHotSpot(15, 9, [24, 36], relativeToMin([[1124.4, 840.7], [1162, 884.3], [1248.3, 884.7], [1195.2, 840.3], [1151.2, 840.5], [1124.4, 840.7]])) //24-36
			this.defineHotSpot(16, 9, [36, 13], relativeToMin([[1064.7, 840.6], [1088.2, 884.4], [1162, 884.3], [1124.4, 840.7], [1092, 840.8], [1064.7, 840.6]])) //36-13
			this.defineHotSpot(17, 9, [13, 1], relativeToMin([[1011.2, 840.3], [1023.1, 883.9], [1088.2, 884.4], [1064.7, 840.6], [1036.4, 840.4], [1011.2, 840.3]])) //13-1
			this.defineHotSpot(18, 9, [1, 37], relativeToMin([[963.5, 839.9], [962.8, 884.3], [1023.1, 883.9], [1011.2, 840.3], [987.1, 840], [963.5, 839.9]])) //1-00
			this.defineHotSpot(19, 9, [37, 27], relativeToMin([[914.9, 839.4], [903, 883.9], [962.8, 884.3], [963.5, 839.9], [938.2, 839.7], [914.9, 839.4]]), 0, 0, true, downArra) //00-27
			this.defineHotSpot(20, 9, [27, 10], relativeToMin([[865, 839.3], [838.3, 884.7], [903, 883.9], [914.9, 839.4], [889.2, 839.4], [865, 839.3]]), 0, 0, true, downArra) //27-10
			this.defineHotSpot(21, 9, [10, 25], relativeToMin([[804.4, 839.5], [762, 885], [838.3, 884.7], [865, 839.3], [836.3, 839.8], [804.4, 839.5]]), 0, 0, true, downArra) //10-25
			this.defineHotSpot(22, 9, [25, 29], relativeToMin([[736.7, 839.9], [677.8, 884.4], [762, 885], [804.4, 839.5], [773.6, 839.7], [736.7, 839.9]]), 0, 0, true, downArra) //25-29
			if (debug_numbers) {
				this.hotSpotsTableTrack[14][9].setVisible(false)
				this.hotSpotsTableTrack[15][9].setVisible(false)
				this.hotSpotsTableTrack[16][9].setVisible(false)
				this.hotSpotsTableTrack[17][9].setVisible(false)
				this.hotSpotsTableTrack[18][9].setVisible(false)
				this.hotSpotsTableTrack[19][9].setVisible(false)
				this.hotSpotsTableTrack[20][9].setVisible(false)
				this.hotSpotsTableTrack[21][9].setVisible(false)
				this.hotSpotsTableTrack[22][9].setVisible(false)
			}

			//kavali levo 
			this.defineHotSpot(23, 9, [29, 12], relativeToMin([[647.1, 837.4], [575.7, 878.2], [677.8, 884.4], [736.7, 839.9], [695.6, 839.7], [647.1, 837.4]]), 0, 0, true, downArra) //29-12
			this.defineHotSpot(24, 9, [12, 8], relativeToMin([[572.4, 822.7], [493, 856], [575.7, 878.2], [647.1, 837.4], [611.1, 831.4], [572.4, 822.7]]), 0, 0, true, downArra) //12-8
			this.defineHotSpot(25, 9, [8, 19], relativeToMin([[492.9, 791.9], [415.7, 813.2], [493, 856], [572.4, 822.7], [529.7, 808.7], [492.9, 791.9]]), 0, 0, true, downArra) //8-19
			this.defineHotSpot(0, 10, [19, 31], relativeToMin([[437, 747.3], [361.1, 760.1], [415.7, 813.2], [492.9, 791.9], [464.1, 771.8], [437, 747.3]]), 0, 0, true, downArra) //19-31
			this.defineHotSpot(1, 10, [31, 18], relativeToMin([[408.6, 698.2], [333.3, 701.3], [361.1, 760.1], [437, 747.3], [421.3, 726], [408.6, 698.2]]), 0, 0, true, downArra) //31-18
			this.defineHotSpot(2, 10, [18, 6], relativeToMin([[407.8, 645.5], [334.1, 642.2], [333.3, 701.3], [408.6, 698.2], [405.4, 672.5], [407.8, 645.5]])) //18-6
			this.defineHotSpot(3, 10, [6, 21], relativeToMin([[436.2, 593.7], [359.9, 585.3], [334.1, 642.2], [407.8, 645.5], [418.2, 619.2], [436.2, 593.7]])) //6-21
			this.defineHotSpot(4, 10, [21, 33], relativeToMin([[490.4, 551.2], [413.6, 531.2], [359.9, 585.3], [436.2, 593.7], [458.2, 571.8], [490.4, 551.2]])) //21-33
			this.defineHotSpot(5, 10, [33, 16], relativeToMin([[566.5, 518.7], [486.4, 491.4], [413.6, 531.2], [490.4, 551.2], [524.1, 533.8], [566.5, 518.7]])) //33-16
			this.defineHotSpot(6, 10, [16, 4], relativeToMin([[648.7, 503.7], [582.4, 465], [486.4, 491.4], [566.5, 518.7], [605.9, 509.9], [648.7, 503.7]])) //16-4
			if (debug_numbers) {
				this.hotSpotsTableTrack[23][9].setVisible(false)
				this.hotSpotsTableTrack[24][9].setVisible(false)
				this.hotSpotsTableTrack[25][9].setVisible(false)
				this.hotSpotsTableTrack[0][10].setVisible(false)
				this.hotSpotsTableTrack[1][10].setVisible(false)
				this.hotSpotsTableTrack[2][10].setVisible(false)
				this.hotSpotsTableTrack[3][10].setVisible(false)
				this.hotSpotsTableTrack[4][10].setVisible(false)
				this.hotSpotsTableTrack[5][10].setVisible(false)
				this.hotSpotsTableTrack[6][10].setVisible(false)
			}
		} else {
			// zgornji ravni del elipse
			this.defineHotSpot(8, 1, [12], relativeToMin([[622, 460], [524, 400], [648, 396], [720, 458]]), 0, 0, true, upArra) // 12
			this.defineHotSpot(24, 3, [35], relativeToMin([[720, 458], [648, 396], [753, 396], [801, 458]]), 10, 0, true, upArra) // 35
			this.defineHotSpot(2, 1, [3], relativeToMin([[753, 396], [801, 458], [870, 458], [842, 396]]), 10, 0, true, upArra) // 3
			this.defineHotSpot(18, 3, [26], relativeToMin([[870, 458], [842, 396], [923, 396], [933, 458]]), 5, 0, true, upArra) // 26
			this.defineHotSpot(0, 3, [0], relativeToMin([[923, 396], [933, 458], [1003, 396], [994, 458]]), 0, 0, true, upArra) // 0
			this.defineHotSpot(22, 3, [32], relativeToMin([[1003, 396], [994, 458], [1085, 396], [1057, 458]]), 0, 0, true, upArra) // 32
			this.defineHotSpot(10, 1, [15], relativeToMin([[1085, 396], [1057, 458], [1174, 396], [1127, 458]]), -13, 0, true, upArra) // 15
			this.defineHotSpot(14, 5, [19], relativeToMin([[1174, 396], [1127, 458], [1278, 396], [1208, 458]]), -7, 0, true, upArra) // 19
			this.defineHotSpot(4, 5, [4], relativeToMin([[1278, 396], [1208, 458], [1401, 396], [1307, 460]]), 0, 0, true, upArra) // 4

			// spodnji ravni del elipse
			this.defineHotSpot(2, 5, [1], relativeToMin([[567, 874], [465, 928], [582, 947], [667, 885]]), 0, 0, true, downArra, upDownKavalSize) // 1
			this.defineHotSpot(22, 1, [33], relativeToMin([[667, 885], [582, 947], [698, 950], [758, 885]]), 5, 0, true, downArra, upDownKavalSize) // 33
			this.defineHotSpot(12, 5, [16], relativeToMin([[758, 885], [698, 950], [795, 950], [833, 885]]), 10, 0, true, downArra, upDownKavalSize) // 16
			this.defineHotSpot(16, 1, [24], relativeToMin([[833, 885], [795, 950], [880, 950], [900, 885]]), 10, 0, true, downArra, upDownKavalSize) // 24
			this.defineHotSpot(4, 3, [5], relativeToMin([[900, 885], [880, 950], [963, 950], [962, 885]]), 5, 0, true, downArra, upDownKavalSize) // 5
			this.defineHotSpot(8, 5, [10], relativeToMin([[962, 885], [963, 950], [1044, 950], [1026, 885]]), -5, 0, true, downArra, upDownKavalSize) // 10
			this.defineHotSpot(16, 3, [23], relativeToMin([[1026, 885], [1044, 950], [1129, 950], [1092, 885]]), -7, 0, true, downArra, upDownKavalSize) // 23
			this.defineHotSpot(6, 3, [8], relativeToMin([[1092, 885], [1129, 950], [1225, 950], [1167, 885]]), 0, 0, true, downArra, upDownKavalSize) // 8
			this.defineHotSpot(20, 1, [30], relativeToMin([[1167, 885], [1225, 950], [1342, 950], [1258, 885]]), 0, 0, true, downArra, upDownKavalSize) // 30
			this.defineHotSpot(8, 3, [11], relativeToMin([[1258, 885], [1342, 950], [1462, 929], [1359, 875]]), -5, 0, true, downArra, upDownKavalSize) // 11

			// leva stran
			this.defineHotSpot(14, 3, [20], relativeToMin([[567, 874], [465, 928], [368, 886], [478, 845]]), 0, 0, true, leftArra) // 20
			this.defineHotSpot(10, 3, [14], relativeToMin([[478, 845], [368, 886], [298, 827], [406, 801]]), -3, -2, true, leftArra) // 14
			this.defineHotSpot(22, 5, [31], relativeToMin([[406, 801], [298, 827], [254, 759], [358, 746]]), -3, -2, true, leftArra) // 31
			this.defineHotSpot(6, 1, [9], relativeToMin([[358, 746], [254, 759], [232, 688], [338, 685]]), 0, 0, true, leftArra) // 9
			this.defineHotSpot(16, 5, [22], relativeToMin([[338, 685], [232, 688], [239, 615], [346, 623]]), -5, 3, true, leftArra) // 22
			this.defineHotSpot(12, 1, [18], relativeToMin([[346, 623], [239, 615], [272, 545], [382, 565]]), -5, 0, true, leftArra) // 18
			this.defineHotSpot(20, 3, [29], relativeToMin([[382, 565], [272, 545], [331, 482], [443, 515]]), -8, 0, true, leftArra) // 29
			this.defineHotSpot(6, 5, [7], relativeToMin([[443, 515], [331, 482], [416, 431], [526, 479]]), 0, 0, true, leftArra) // 7
			this.defineHotSpot(20, 5, [28], relativeToMin([[526, 479], [416, 431], [524, 400], [622, 460]]), 0, 0, true, new Array(BET_CHECKING_MODE.LEFT, BET_CHECKING_MODE.TOP)) // 28

			// desna stran
			this.defineHotSpot(24, 1, [36], relativeToMin([[1359, 875], [1462, 929], [1559, 886], [1451, 846]]), 0, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.BOTTOM), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) // 36
			this.defineHotSpot(10, 5, [13], relativeToMin([[1451, 846], [1559, 886], [1629, 828], [1523, 802]]), 3, -3, true, rightArra, { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) // 13
			this.defineHotSpot(18, 1, [27], relativeToMin([[1523, 802], [1629, 828], [1674, 760], [1571, 747]]), 4, -4, true, rightArra, leftRightKavalSize) // 27
			this.defineHotSpot(4, 1, [6], relativeToMin([[1571, 747], [1674, 760], [1693, 688], [1592, 686]]), 0, 0, true, rightArra, leftRightKavalSize) // 6
			this.defineHotSpot(24, 5, [34], relativeToMin([[1592, 686], [1693, 688], [1688, 616], [1585, 624]]), 0, 0, true, rightArra, leftRightKavalSize) // 34
			this.defineHotSpot(12, 3, [17], relativeToMin([[1585, 624], [1688, 616], [1655, 546], [1549, 565]]), 0, 0, true, rightArra, leftRightKavalSize) // 17
			this.defineHotSpot(18, 5, [25], relativeToMin([[1549, 565], [1655, 546], [1597, 483], [1487, 516]]), 5, 0, true, rightArra, leftRightKavalSize) // 25
			this.defineHotSpot(2, 3, [2], relativeToMin([[1487, 516], [1597, 483], [1514, 432], [1404, 479]]), 5, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.TOP), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) // 2
			this.defineHotSpot(14, 1, [21], relativeToMin([[1404, 479], [1514, 432], [1401, 400], [1307, 460]]), 0, 0, true, new Array(BET_CHECKING_MODE.RIGHT, BET_CHECKING_MODE.TOP), { width: leftRightKavalSize.width + 100, height: leftRightKavalSize.height + 100 }) // 21

						/** KAVALI NA TRACKU */
			//kavali zgoraj
			this.defineHotSpot(6, 10, [28, 12], relativeToMin([[636, 504], [575, 467], [674, 458], [720, 500]])) //28-12
			this.defineHotSpot(7, 10, [12, 35], relativeToMin([[720, 500], [674, 458], [764, 458], [796, 500]])) //12-35
			this.defineHotSpot(8, 10, [35, 3], relativeToMin([[796, 500], [764, 458], [838, 458], [857, 500]])) //35-3
			this.defineHotSpot(9, 10, [3, 26], relativeToMin([[857, 500], [838, 458], [905, 458], [914, 500]])) //3-26
			this.defineHotSpot(10, 10, [26, 0], relativeToMin([[914, 500], [905, 458], [965, 458], [965, 500]])) //26-0
			this.defineHotSpot(0, 9, [0, 32], relativeToMin([[965, 500], [965, 458], [1027, 458], [1016, 500]])) //0-32
			this.defineHotSpot(1, 9, [32, 15], relativeToMin([[1016, 500], [1027, 458], [1092, 458], [1070, 500]])) //32-15
			this.defineHotSpot(2, 9, [15, 19], relativeToMin([[1070, 500], [1092, 458], [1168, 458], [1132, 500]])) //15-19
			this.defineHotSpot(3, 9, [19, 4], relativeToMin([[1132, 500], [1168, 458], [1262, 458], [1206, 500]])) //19-4
			this.defineHotSpot(4, 9, [4, 21], relativeToMin([[1206, 500], [1262, 458], [1358, 468], [1296, 505]])) //4-21

			//kavali desno 21-2-25-17
			this.defineHotSpot(5, 9, [21, 2], relativeToMin([[1296, 505], [1358, 468], [1450, 497], [1379, 525]])) //21-2
			this.defineHotSpot(6, 9, [2, 25], relativeToMin([[1379, 525], [1450, 497], [1523, 541], [1449, 560]])) //2-25
			this.defineHotSpot(7, 9, [25, 17], relativeToMin([[1449, 560], [1523, 541], [1572, 597], [1499, 607]])) //25-17
			this.defineHotSpot(8, 9, [17, 34], relativeToMin([[1499, 607], [1572, 597], [1592, 656], [1519, 660]])) //17-34
			this.defineHotSpot(9, 9, [34, 6], relativeToMin([[1519, 660], [1592, 656], [1584, 718], [1512, 711]])) //34-6
			this.defineHotSpot(10, 9, [6, 27], relativeToMin([[1512, 711], [1584, 718], [1549, 777], [1476, 760]])) //6-27
			this.defineHotSpot(11, 9, [27, 13], relativeToMin([[1476, 760], [1549, 777], [1488, 826], [1417, 799]])) //27-13
			this.defineHotSpot(12, 9, [13, 36], relativeToMin([[1417, 799], [1488, 826], [1406, 862], [1336, 828]])) //13-36
			this.defineHotSpot(13, 9, [36, 11], relativeToMin([[1336, 828], [1406, 862], [1311, 882], [1250, 842]])) //36-11

			//kavali spodaj
			this.defineHotSpot(14, 9, [11, 30], relativeToMin([[1250, 842], [1311, 882], [1214, 885], [1167, 842]]), 0, 0, true, downArra) //11-30
			this.defineHotSpot(15, 9, [30, 8], relativeToMin([[1167, 842], [1214, 885], [1131, 885], [1098, 842]]), 0, 0, true, downArra) //30-8
			this.defineHotSpot(16, 9, [8, 23], relativeToMin([[1098, 842], [1131, 885], [1062, 885], [1042, 842]]), 0, 0, true, downArra) //8-23
			this.defineHotSpot(17, 9, [23, 10], relativeToMin([[1042, 842], [1062, 885], [996, 885], [990, 842]]), 0, 0, true, downArra) //23-10
			this.defineHotSpot(18, 9, [10, 5], relativeToMin([[990, 842], [996, 885], [930, 885], [940, 842]]), 0, 0, true, downArra) //10-5
			this.defineHotSpot(19, 9, [5, 24], relativeToMin([[940, 842], [930, 885], [868, 885], [887, 842]]), 0, 0, true, downArra) //5-24
			this.defineHotSpot(20, 9, [24, 16], relativeToMin([[887, 842], [868, 885], [793, 885], [827, 842]]), 0, 0, true, downArra) //24-16
			this.defineHotSpot(21, 9, [16, 33], relativeToMin([[827, 842], [793, 885], [715, 885], [761, 842]]), 0, 0, true, downArra) //16-33
			this.defineHotSpot(22, 9, [33, 1], relativeToMin([[761, 842], [715, 885], [614, 882], [680, 842]]), 0, 0, true, downArra) //33-1

			//kavali levo 20-14-31
			this.defineHotSpot(23, 9, [1, 20], relativeToMin([[680, 842], [614, 882], [522, 863], [592, 829]])) //1-20
			this.defineHotSpot(24, 9, [20, 14], relativeToMin([[592, 829], [522, 863], [440, 826], [510, 802]])) //20-14
			this.defineHotSpot(25, 9, [14, 31], relativeToMin([[510, 802], [440, 826], [380, 777], [449, 762]])) //14-31
			this.defineHotSpot(0, 10, [31, 9], relativeToMin([[449, 762], [380, 777], [345, 716], [411, 710]])) //31-9
			this.defineHotSpot(1, 10, [9, 22], relativeToMin([[411, 710], [345, 716], [338, 658], [405, 655]])) //9-22
			this.defineHotSpot(2, 10, [22, 18], relativeToMin([[405, 655], [338, 658], [360, 594], [427, 603]])) //22-18
			this.defineHotSpot(3, 10, [18, 29], relativeToMin([[427, 603], [360, 594], [408, 539], [477, 558]])) //18-29
			this.defineHotSpot(4, 10, [29, 7], relativeToMin([[477, 558], [408, 539], [483, 494], [548, 524]])) //29-7
			this.defineHotSpot(5, 10, [7, 28], relativeToMin([[548, 524], [483, 494], [575, 467], [636, 504]])) //7-28

		}

		this.hotSpotsTableTrack.forEach(x => {
			x.forEach(element => {
				this.add(element)
				this.bringToTop(element)
			});
		});

	}

	protected InitializeNormalHotSpotOffsets(): void {
		if (Client.logic.IsDoubleZero()) {
			this.normalHotSpotOffsetsDictionary["0"] = { offsetX: -2, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["1"] = { offsetX: 7, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["2"] = { offsetX: -8, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["3"] = { offsetX: 42, offsetY: 19 };
			this.normalHotSpotOffsetsDictionary["4"] = { offsetX: -40, offsetY: -19 };
			this.normalHotSpotOffsetsDictionary["5"] = { offsetX: 41, offsetY: -1 };
			this.normalHotSpotOffsetsDictionary["6"] = { offsetX: -41, offsetY: 1 };
			this.normalHotSpotOffsetsDictionary["7"] = { offsetX: 38, offsetY: -18 };
			this.normalHotSpotOffsetsDictionary["8"] = { offsetX: -41, offsetY: 14 };
			this.normalHotSpotOffsetsDictionary["9"] = { offsetX: 11, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["10"] = { offsetX: -9, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["11"] = { offsetX: 33, offsetY: -22 };
			this.normalHotSpotOffsetsDictionary["12"] = { offsetX: -31, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["13"] = { offsetX: 13, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["14"] = { offsetX: -15, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["15"] = { offsetX: 43, offsetY: 14 };
			this.normalHotSpotOffsetsDictionary["16"] = { offsetX: -41, offsetY: -14 };
			this.normalHotSpotOffsetsDictionary["17"] = { offsetX: 40, offsetY: -2 };
			this.normalHotSpotOffsetsDictionary["18"] = { offsetX: -41, offsetY: 2 };
			this.normalHotSpotOffsetsDictionary["19"] = { offsetX: -42, offsetY: 10 };
			this.normalHotSpotOffsetsDictionary["20"] = { offsetX: 41, offsetY: -11 };
			this.normalHotSpotOffsetsDictionary["21"] = { offsetX: -41, offsetY: -4 };
			this.normalHotSpotOffsetsDictionary["22"] = { offsetX: 41, offsetY: 3 };
			this.normalHotSpotOffsetsDictionary["23"] = { offsetX: -31, offsetY: -21 };
			this.normalHotSpotOffsetsDictionary["24"] = { offsetX: 31, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["25"] = { offsetX: -16, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["26"] = { offsetX: 18, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["27"] = { offsetX: -3, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["28"] = { offsetX: 5, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["29"] = { offsetX: -27, offsetY: 22 };
			this.normalHotSpotOffsetsDictionary["30"] = { offsetX: 30, offsetY: -22 };
			this.normalHotSpotOffsetsDictionary["31"] = { offsetX: -41, offsetY: 5 };
			this.normalHotSpotOffsetsDictionary["32"] = { offsetX: 43, offsetY: -7 };
			this.normalHotSpotOffsetsDictionary["33"] = { offsetX: -42, offsetY: -7 };
			this.normalHotSpotOffsetsDictionary["34"] = { offsetX: 43, offsetY: 9 };
			this.normalHotSpotOffsetsDictionary["35"] = { offsetX: -22, offsetY: -23 };
			this.normalHotSpotOffsetsDictionary["36"] = { offsetX: 20, offsetY: 23 };
			this.normalHotSpotOffsetsDictionary["37"] = { offsetX: 2, offsetY: 23 };
		} else {
			this.normalHotSpotOffsetsDictionary["0"] = { offsetX: 0, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["1"] = { offsetX: -25, offsetY: 17 };
			this.normalHotSpotOffsetsDictionary["2"] = { offsetX: 30, offsetY: -10 };
			this.normalHotSpotOffsetsDictionary["3"] = { offsetX: -15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["4"] = { offsetX: 15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["5"] = { offsetX: 0, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["6"] = { offsetX: 35, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["7"] = { offsetX: -30, offsetY: -10 };
			this.normalHotSpotOffsetsDictionary["8"] = { offsetX: 10, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["9"] = { offsetX: -30, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["10"] = { offsetX: 0, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["11"] = { offsetX: 30, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["12"] = { offsetX: -15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["13"] = { offsetX: 33, offsetY: 13 };
			this.normalHotSpotOffsetsDictionary["14"] = { offsetX: -35, offsetY: 10 };
			this.normalHotSpotOffsetsDictionary["15"] = { offsetX: 15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["16"] = { offsetX: -15, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["17"] = { offsetX: 35, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["18"] = { offsetX: -30, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["19"] = { offsetX: 15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["20"] = { offsetX: -35, offsetY: 13 };
			this.normalHotSpotOffsetsDictionary["21"] = { offsetX: 30, offsetY: -19 };
			this.normalHotSpotOffsetsDictionary["22"] = { offsetX: -30, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["23"] = { offsetX: 10, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["24"] = { offsetX: -7, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["25"] = { offsetX: 35, offsetY: -7 };
			this.normalHotSpotOffsetsDictionary["26"] = { offsetX: 0, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["27"] = { offsetX: 33, offsetY: 7 };
			this.normalHotSpotOffsetsDictionary["28"] = { offsetX: -35, offsetY: -15 };
			this.normalHotSpotOffsetsDictionary["29"] = { offsetX: -30, offsetY: -5 };
			this.normalHotSpotOffsetsDictionary["30"] = { offsetX: 10, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["31"] = { offsetX: -33, offsetY: 6 };
			this.normalHotSpotOffsetsDictionary["32"] = { offsetX: 0, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["33"] = { offsetX: -15, offsetY: 20 };
			this.normalHotSpotOffsetsDictionary["34"] = { offsetX: 35, offsetY: 0 };
			this.normalHotSpotOffsetsDictionary["35"] = { offsetX: -15, offsetY: -20 };
			this.normalHotSpotOffsetsDictionary["36"] = { offsetX: 37, offsetY: 16 };
		}
	}

	//What the fuck is this shit ?
	protected InitializeExistingHotSpotOffsets(): void {
		if (Client.logic.IsDoubleZero()) {
			this.initializedHotSpotOfssetsDictionary["0"] = { offsetX: 34, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["1"] = { offsetX: -40, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["2"] = { offsetX: 41, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["3"] = { offsetX: -90, offsetY: -28 };
			this.initializedHotSpotOfssetsDictionary["4"] = { offsetX: 95, offsetY: 19 };
			this.initializedHotSpotOfssetsDictionary["5"] = { offsetX: -60, offsetY: 0 };
			this.initializedHotSpotOfssetsDictionary["6"] = { offsetX: 57, offsetY: -45 };
			this.initializedHotSpotOfssetsDictionary["7"] = { offsetX: -10, offsetY: 33 };
			this.initializedHotSpotOfssetsDictionary["8"] = { offsetX: 10, offsetY: -40 };
			this.initializedHotSpotOfssetsDictionary["9"] = { offsetX: 5, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["10"] = { offsetX: -13, offsetY: -32 };
			this.initializedHotSpotOfssetsDictionary["11"] = { offsetX: 0, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["12"] = { offsetX: 0, offsetY: -36 };
			this.initializedHotSpotOfssetsDictionary["13"] = { offsetX: -50, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["14"] = { offsetX: 53, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["15"] = { offsetX: -95, offsetY: -17 };
			this.initializedHotSpotOfssetsDictionary["16"] = { offsetX: 90, offsetY: 2 };
			this.initializedHotSpotOfssetsDictionary["17"] = { offsetX: -40, offsetY: 12 };
			this.initializedHotSpotOfssetsDictionary["18"] = { offsetX: 40, offsetY: -57 };
			this.initializedHotSpotOfssetsDictionary["19"] = { offsetX: 18, offsetY: -48 };
			this.initializedHotSpotOfssetsDictionary["20"] = { offsetX: -15, offsetY: 26 };
			this.initializedHotSpotOfssetsDictionary["21"] = { offsetX: 65, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["22"] = { offsetX: -75, offsetY: 0 };
			this.initializedHotSpotOfssetsDictionary["23"] = { offsetX: 89, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["24"] = { offsetX: -80, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["25"] = { offsetX: -10, offsetY: -32 };
			this.initializedHotSpotOfssetsDictionary["26"] = { offsetX: 0, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["27"] = { offsetX: -17, offsetY: -32 };
			this.initializedHotSpotOfssetsDictionary["28"] = { offsetX: 19, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["29"] = { offsetX: -5, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["30"] = { offsetX: 0, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["31"] = { offsetX: 28, offsetY: -53 };
			this.initializedHotSpotOfssetsDictionary["32"] = { offsetX: -27, offsetY: 19 };
			this.initializedHotSpotOfssetsDictionary["33"] = { offsetX: 80, offsetY: -13 };
			this.initializedHotSpotOfssetsDictionary["34"] = { offsetX: -90, offsetY: -5 };
			this.initializedHotSpotOfssetsDictionary["35"] = { offsetX: 66, offsetY: 22 };
			this.initializedHotSpotOfssetsDictionary["36"] = { offsetX: -65, offsetY: -33 };
			this.initializedHotSpotOfssetsDictionary["37"] = { offsetX: -30, offsetY: -32 };
		} else {
			this.initializedHotSpotOfssetsDictionary["0"] = { offsetX: 25, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["1"] = { offsetX: 12, offsetY: 402 };
			this.initializedHotSpotOfssetsDictionary["2"] = { offsetX: -10, offsetY: 75 };
			this.initializedHotSpotOfssetsDictionary["3"] = { offsetX: 50, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["4"] = { offsetX: 1, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["5"] = { offsetX: -15, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["6"] = { offsetX: -65, offsetY: 290 };
			this.initializedHotSpotOfssetsDictionary["7"] = { offsetX: 103, offsetY: 44 };
			this.initializedHotSpotOfssetsDictionary["8"] = { offsetX: -60, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["9"] = { offsetX: 45, offsetY: 233 };
			this.initializedHotSpotOfssetsDictionary["10"] = { offsetX: -40, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["11"] = { offsetX: -95, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["12"] = { offsetX: 100, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["13"] = { offsetX: -90, offsetY: 378 };
			this.initializedHotSpotOfssetsDictionary["14"] = { offsetX: 25, offsetY: 342 };
			this.initializedHotSpotOfssetsDictionary["15"] = { offsetX: 1, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["16"] = { offsetX: 1, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["17"] = { offsetX: -40, offsetY: 175 };
			this.initializedHotSpotOfssetsDictionary["18"] = { offsetX: 75, offsetY: 117 };
			this.initializedHotSpotOfssetsDictionary["19"] = { offsetX: 1, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["20"] = { offsetX: 15, offsetY: 379 };
			this.initializedHotSpotOfssetsDictionary["21"] = { offsetX: 1, offsetY: 45 };
			this.initializedHotSpotOfssetsDictionary["22"] = { offsetX: 60, offsetY: 172 };
			this.initializedHotSpotOfssetsDictionary["23"] = { offsetX: -45, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["24"] = { offsetX: -10, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["25"] = { offsetX: -25, offsetY: 120 };
			this.initializedHotSpotOfssetsDictionary["26"] = { offsetX: 40, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["27"] = { offsetX: -75, offsetY: 339 };
			this.initializedHotSpotOfssetsDictionary["28"] = { offsetX: 100, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["29"] = { offsetX: 85, offsetY: 75 };
			this.initializedHotSpotOfssetsDictionary["30"] = { offsetX: -80, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["31"] = { offsetX: 30, offsetY: 292 };
			this.initializedHotSpotOfssetsDictionary["32"] = { offsetX: 5, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["33"] = { offsetX: 5, offsetY: 409 };
			this.initializedHotSpotOfssetsDictionary["34"] = { offsetX: -50, offsetY: 233 };
			this.initializedHotSpotOfssetsDictionary["35"] = { offsetX: 70, offsetY: 30 };
			this.initializedHotSpotOfssetsDictionary["36"] = { offsetX: -95, offsetY: 403 };
		}
	}

	positionTrackHotSpots(): void {
		this.hotSpotsTableTrack.forEach(x => {
			if (x) {
				x.forEach(element => {
					if (element.ButtonsList.length == 1) {
						let b = element.ButtonsList[0]
						if (b) {
							element.setPosition(b.x + this.trackScale * this.normalHotSpotOffsetsDictionary[b.Name].offsetX, b.y + this.trackScale * this.normalHotSpotOffsetsDictionary[b.Name].offsetY)
							element.setScale(this.trackScale)
						}
					} else {
						let b = element.ButtonsList
						if (Client.logic.IsDoubleZero()) {
							let h = b[0].displayHeight
							let y = b[0].y - h / 2
							element.setPosition(b[0].x + this.trackScale * this.initializedHotSpotOfssetsDictionary[b[0].Name].offsetX, y + this.trackScale * this.initializedHotSpotOfssetsDictionary[b[0].Name].offsetY + this.referenceRect.y + this.generalOffsetY);
						} else {
							element.setPosition(b[0].x + this.trackScale * this.initializedHotSpotOfssetsDictionary[b[0].Name].offsetX, this.trackScale * this.initializedHotSpotOfssetsDictionary[b[0].Name].offsetY + this.referenceRect.y + this.generalOffsetY);
						}
						element.setScale(this.trackScale)
					}
				});
			}
		});
	}

	protected createMiscButtons(): void {
		this.redLeftBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Track.Buttons.Track_Red.Normal, Assets.Track.Buttons.Track_Red.Disabled, Assets.Track.Buttons.Track_Red.Hover, new RedLeftTrack(), false, Messages.LEFT_REDS)
		this.redLeftBtn.name = Constants.TRACK.MISC_BUTTON_NAMES.RED_LEFT_TRACK
		this.add(this.redLeftBtn)
		this.add(this.redLeftBtn.TextElement)

		this.blackLeftBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Track.Buttons.Track_Black.Normal, Assets.Track.Buttons.Track_Black.Disabled, Assets.Track.Buttons.Track_Black.Hover, new BlackLeftTrack(), false, Messages.LEFT_BLACKS)
		this.blackLeftBtn.name = Constants.TRACK.MISC_BUTTON_NAMES.BLACK_LEFT_TRACK
		this.add(this.blackLeftBtn)
		this.add(this.blackLeftBtn.TextElement)

		this.redRightBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Track.Buttons.Track_Red.Normal, Assets.Track.Buttons.Track_Red.Disabled, Assets.Track.Buttons.Track_Red.Hover, new RedRightTrack(), false, Messages.RIGHT_REDS)
		this.redRightBtn.name = Constants.TRACK.MISC_BUTTON_NAMES.RED_RIGHT_TRACK
		this.add(this.redRightBtn)
		this.add(this.redRightBtn.TextElement)

		this.blackRightBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Track.Buttons.Track_Black.Normal, Assets.Track.Buttons.Track_Black.Disabled, Assets.Track.Buttons.Track_Black.Hover, new BlackRightTrack(), false, Messages.RIGHT_BLACKS)
		this.blackRightBtn.name = Constants.TRACK.MISC_BUTTON_NAMES.BLACK_RIGHT_TRACK
		this.add(this.blackRightBtn)
		this.add(this.blackRightBtn.TextElement)

		this.switchLayoutBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Track.Buttons.Board_Switch.Normal, Assets.Track.Buttons.Board_Switch.Disabled, Assets.Track.Buttons.Board_Switch.Hover, new ToggleLayout(), false, Messages.TABLE_LAYOUT)
		this.switchLayoutBtn.name = Constants.BOARD.MISC_BUTTON_NAMES.SWITCH_LAYOUT
		this.add(this.switchLayoutBtn)
		this.add(this.switchLayoutBtn.TextElement)

		this.repeatBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Board.Buttons.Repeat_Bets.Normal, Assets.Board.Buttons.Repeat_Bets.Disabled, Assets.Board.Buttons.Repeat_Bets.Hover, new RepeatBets(), false, Messages.REPEAT)
		this.repeatBtn.name = Constants.BOARD.MISC_BUTTON_NAMES.REPEAT_BETS
		this.add(this.repeatBtn)
		this.add(this.repeatBtn.TextElement)

		this.undoBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.Board.Buttons.Undo_Bet.Normal, Assets.Board.Buttons.Undo_Bet.Disabled, Assets.Board.Buttons.Undo_Bet.Hover, new UndoBet(), false, Messages.UNDO)
		this.undoBtn.name = Constants.BOARD.MISC_BUTTON_NAMES.UNDO_BET
		this.add(this.undoBtn)
		this.add(this.undoBtn.TextElement)

		this.presetBtn = new MiscButton(this.scene, -1, Constants.SPRITESHEET, Assets.PresetPanel.Buttons.Preset_Switch.Normal, Assets.PresetPanel.Buttons.Preset_Switch.Disabled, Assets.PresetPanel.Buttons.Preset_Switch.Hover, new TogglePresets(this.scene), false, Messages.PRESETS)
		this.presetBtn.name = "PRESETS_BUTTON"
		this.add(this.presetBtn);
		this.add(this.presetBtn.TextElement);
	}

	protected positionMiscButtons(boardWidth: number, buttonW: number, buttonH: number): void {
		let scale = buttonW / this.sourceButton.width;
		let rightPos = buttonW + (Constants.BOARD.RELATIVE_SPACING_ZERO * buttonW * 2) + (buttonW * (12 + 11 * Constants.BOARD.RELATIVE_SPACING_W))

		this.blackLeftBtn.setPosition(0, 0)
		this.blackLeftBtn.setScale(scale)
		this.blackLeftBtn.AlignText();

		this.redLeftBtn.setPosition(0, buttonH * (1 + Constants.BOARD.RELATIVE_SPACING_H))
		this.redLeftBtn.setScale(scale)
		this.redLeftBtn.AlignText();

		this.repeatBtn.setPosition(0, this.height - buttonH * (2 + Constants.BOARD.RELATIVE_SPACING_H))
		this.repeatBtn.setScale(scale)
		this.repeatBtn.AlignText(0.515, 0.7);

		this.undoBtn.setPosition(0, this.height - buttonH)
		this.undoBtn.setScale(scale)
		this.undoBtn.AlignText(0.5, 0.7);

		(this.switchLayoutBtn as MiscButton).setScale(scale);
		(this.switchLayoutBtn as MiscButton).setPosition(rightPos, this.height - buttonH * (2 + Constants.BOARD.RELATIVE_SPACING_H));
		(this.switchLayoutBtn as MiscButton).AlignText(0.5, 0.7);

		this.presetBtn.setScale(scale)
		this.presetBtn.setPosition(rightPos, this.height - buttonH)
		this.presetBtn.AlignText();

		this.blackRightBtn.setPosition(rightPos, 0)
		this.blackRightBtn.setScale(scale)
		this.blackRightBtn.AlignText();

		this.redRightBtn.setPosition(rightPos, buttonH * (1 + Constants.BOARD.RELATIVE_SPACING_H))
		this.redRightBtn.setScale(scale)
		this.redRightBtn.AlignText();
	}

	protected enableHotspots(): void {
		this.hotSpotsTableTrack.forEach(element => {
			element.forEach(element => {
				element.setInteractive()
			});
		});
	}

	protected disableHotspots(): void {
		this.hotSpotsTableTrack.forEach(element => {
			element.forEach(element => {
				element.disableInteractive()
			});
		});
	}

	protected displayWins(winNumber: number): void {
		winNumber = parseInt(winNumber as any)
		if (winNumber == -1) {
			this.trackButtons.forEach(element => {
				element.SetNormal()
			});
			this.PlayWinAnimation(null, winNumber);
			return;
		}

		let winningButton = this.trackButtons[winNumber];
		winningButton.SetWinning();
		if (!Client.logic.IsBoard)
			this.trackBetsDisplay.SetWinPosition(new Phaser.Math.Vector2(winningButton.x + winningButton.displayWidth / 2, winningButton.y + winningButton.displayHeight / 2));

		this.PlayWinAnimation(winningButton, winNumber);
	}

	OnPhaseEvent(phase: number): void {
		//disabling glows on all hotspots on bets are closed phase.
		if (phase == Phase.BALL_OUT_STATE || phase == Phase.WAITING_WIN_NUMBER_STATE) {
			this.hotSpotsTableTrack.forEach(element => {
				element.forEach(element2 => {
					element2.SetButtonsNormal()
				});
			});
		};
	}

	ToggleButtonsHighLight(hotSpots: Array<number>, highlighted: boolean) {
		if (!hotSpots) {
			this.hotSpotsTableTrack.forEach(element => {
				element.forEach(element2 => {
					highlighted ? element2.SetButtonsHighlighted() : element2.SetButtonsNormal()
				})
			})
		} else {
			hotSpots.forEach(element => {
				(highlighted) ? this.trackButtons[element.toString()].SetWinning() : this.trackButtons[element.toString()].SetNormal();
			});
		}
	}

	ToggleHotSpotsEffects(enabled: boolean) {
		this.hotSpotsTableTrack.forEach(element => {
			element.forEach(element2 => {
				element2.ToggleEffectsEnabled(enabled);
			});
		});
	}

	OnResize(width: number, height: number, boardWidth: number, boardY: number, portraitMode: boolean, boardHeight: number): void {
		if (this.zeroGameCenterPresetText && this.bigSeriesCenterPresetText && this.orphansCenterPresetText && this.secondaryOrphansText) {
			this.zeroGameCenterPresetText.text = Language.Get(Messages.ZERO_GAME);
			this.bigSeriesCenterPresetText.text = Language.Get(Messages.TRACK_BIG_SERIES);
			this.orphansCenterPresetText.text = Language.Get(Messages.ORPHANS);
			this.secondaryOrphansText.text = Language.Get(Messages.ORPHANS);
		}

		if (this.repeatBtn)
			this.repeatBtn.TextElement.text = this.isTrackEmpty ? Language.Get(Messages.REPEAT) : Language.Get(Messages.DOUBLE);

		if (this.winAnimation)
			this.winAnimation.forEach(tween => {
				tween.stop();
			});

		let buttonW = boardWidth / (14 + 11 * Constants.BOARD.RELATIVE_SPACING_H + 2 * Constants.BOARD.RELATIVE_SPACING_ZERO)
		let sourceButtonDimensions = { width: this.sourceButton.width, height: this.sourceButton.height }
		let sourceButtonRatio = sourceButtonDimensions.width / sourceButtonDimensions.height
		this.positionTrackButtons(width, height, boardY, buttonW, buttonW / sourceButtonRatio, portraitMode, boardHeight) // ta tudi nastavi pozicijo celega tracka
		this.positionTrackHotSpots();
		this.positionMiscButtons(boardWidth, buttonW, buttonW / sourceButtonRatio);

		this.trackBetsDisplay.RefreshChips();

		this.inputRect.setSize(this.width, this.height);
		this.bringToTop(this.inputRect);
		this.inputRect.removeInteractive();
		this.inputRect.setInteractive();

		// Client.game.events.emit('chipReposition')
	}

	protected PlayWinAnimation(winningButton?, winNumber?): void {
		if (winNumber == -1 || !winningButton)
			return;

		//---Track explosion ripple animation--------------------
		if (!Client.logic.historyShown) {
			let maxJumpSize = this.displayHeight / 20;
			let maxDistanceAway = this.displayWidth * 0.8;
			let originalDisplayWidth = winningButton.displayWidth;

			this.trackButtons.forEach(trackButton => {
				let intensityFactor = Math.min(1, Math.max(0, 1 - (Phaser.Math.Distance.BetweenPoints(new Phaser.Math.Vector2(winningButton.x, winningButton.y), new Phaser.Math.Vector2(trackButton.x, trackButton.y)) / maxDistanceAway)));
				let maxExplodeScale = Math.max(trackButton.scale * 1.05, (trackButton.scale * 1.25) * intensityFactor);
				let originalScale = trackButton.scale;
				if (trackButton != winningButton)
					this.sendToBack(trackButton);

				this.winAnimation.push(this.scene.tweens.add({
					targets: [trackButton],
					scale: { from: trackButton.scale, to: maxExplodeScale },
					y: { from: trackButton.y, to: trackButton.y - (maxJumpSize * intensityFactor) },
					x: { from: trackButton.x, to: trackButton.x - (originalDisplayWidth * (maxExplodeScale - originalScale)) / 2 },
					ease: 'Cubic',
					duration: 500 /*+ 200 * intensityFactor*/,
					repeat: 0,
					yoyo: true,
					delay: 1000 * (1 - intensityFactor),
					onComplete: function (tween, targets) {
						this.winAnimation.splice(this.winAnimation.indexOf(tween), 1);
					}.bind(this)
				}));

			});
		}
		//-------------------------------------------------------
	}

	/**********************************STATISTICS**********************************/
	public toggleNumberStatistics(updatePositionsOnly: boolean = false): void {//toggle statistics overlay on		
		if (Client.logic.CurrentHistoryNumbers.length <= 0)
			return;

		if (!this.statisticsAreDisplayed || updatePositionsOnly) {
			this.statisticsAreDisplayed = true;

			if (!this.numberStatistics && !updatePositionsOnly)
				this.updateStatistics(true);

			if (!updatePositionsOnly)
				this.statisticsBars = new Array(this.numberStatistics.length);

			this.numberStatistics.forEach((mn, i) => {
				let percentage = mn.count / Client.logic.CurrentHistoryNumbers.length;

				if (!this.statisticsBars[i] && !updatePositionsOnly) {
					this.statisticsBars[mn.num] = new StatsHolder(this.scene);
					this.add(this.statisticsBars[mn.num]);
					this.statisticsBars[mn.num].setPosition(this.trackButtons[mn.num].x, this.trackButtons[mn.num].y);
					this.statisticsBars[mn.num].UpdateValues(this.trackButtons[i].displayWidth, this.trackButtons[i].displayHeight, mn.num, percentage, Client.logic.currentGameState.HotNumbers.includes(i), Client.logic.currentGameState.ColdNumbers.includes(i));
				}
				else {
					this.statisticsBars[mn.num].setPosition(this.trackButtons[mn.num].x, this.trackButtons[mn.num].y);
					this.statisticsBars[mn.num].UpdateValues(this.trackButtons[i].displayWidth, this.trackButtons[i].displayHeight, mn.num, percentage, Client.logic.currentGameState.HotNumbers.includes(i), Client.logic.currentGameState.ColdNumbers.includes(i));
				}
			})

			this.bringToTop(this.trackBetsDisplay.ChipContainer);
		}
		else {
			this.statisticsAreDisplayed = false;

			this.statisticsBars.forEach(st => {
				st.DestroyAll()
				st.destroy()
				st = null
				this.remove(st, true)
			})

			this.statisticsBars.splice(0, this.statisticsBars.length);
		}
	}

	protected updateStatistics(selfUpdate: boolean = false): void {//call at start of every bets open and first toggle of statistics
		if (Client.logic.CurrentHistoryNumbers.length <= 0)
			return;

		this.numberStatistics = Client.logic.CalculateWinNumberStatistics();

		if (this.statisticsAreDisplayed && !selfUpdate) {//update statistics if visible
			this.toggleNumberStatistics(true);
		}
	}
	/******************************************************************************/
}

export class TrackCenterPreset extends Phaser.GameObjects.Polygon {
	constructor(scene: Phaser.Scene, points: any, presetName: string, private betsDisplay: BetsDisplay, color?: number) {
		super(scene, 0, 0, points, color ? color : 0x00FF00, 0)
		this.alpha = 1
		this.name = presetName;
		this.setInteractive(new Phaser.Geom.Polygon(points), Phaser.Geom.Polygon.Contains)
		this.on("pointerdown", (pointer) => {
			this.onPointerDown()
		})
		this.on("pointermove", () => { this.onPointerMove() }, this);
	}

	onPointerMove(): void {
		this.betsDisplay.ToggleTouchPointer(false);
	}

	onPointerDown() {
		if (Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) return
		switch (this.name) {
			case Constants.TRACK.BET_NAMES.ZERO_GAME:
				Client.logic.TrackZerroGame();
				break;
			case Constants.TRACK.BET_NAMES.BIG_SERIES:
				Client.logic.TrackBigSeries();
				break;
			case Constants.TRACK.BET_NAMES.ORPHANS:
				Client.logic.TrackOprhans();
				break;
			case Constants.TRACK.BET_NAMES.SERIE_58:
				Client.logic.TrackSerie58();
				break;
			case Constants.TRACK.BET_NAMES.LESFIGURES_NASSA:
				Client.logic.TrackNassa();
		}
	}
}

class ToggleLayout implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.ToggleTrackView()
	}
}

class TogglePresets implements ButtonAction {
	constructor(private scene: Phaser.Scene) {

	}

	Action(): void {
		this.scene.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		this.scene.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, -1)
		this.scene.sound.play(Constants.SOUNDS.SLIDER_CHANGE, { volume: 0.20 * effectsVolume })
	}
}